<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="id"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <med-form-webservice-base-complex
            [id]="id"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [webserviceConfig]="webserviceConfig"
            [records]="records"
            [multiple]="multiple"
            [searchLabel]="searchLabel"
            [indeterminateMsg]="indeterminateMsg"
            [placeholderMsg]="placeholderMsg"
            [maxValuesMsg]="maxValuesMsg"
            [isDisabled]="control.disabled"
            [disabledMsg]="disabledMsg"
        ></med-form-webservice-base-complex>
    </ng-template>

    <ng-template #simple>
        <med-form-webservice-base
            [id]="id"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [webserviceConfig]="webserviceConfig"
            [records]="records"
            [multiple]="multiple"
            [searchLabel]="searchLabel"
            [indeterminateMsg]="indeterminateMsg"
            [placeholderMsg]="placeholderMsg"
            [maxValuesMsg]="maxValuesMsg"
            [isDisabled]="control.disabled"
            [disabledMsg]="disabledMsg"
        ></med-form-webservice-base>
    </ng-template>
</sh-form-group>
